// LiveStreamCupidGiftEntry.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamCupidGiftEntry from '../component/LiveStreamCupidGiftEntry.jsx';
import getMeData from '../selector/getMeData.js';
import setUsingGameId from '../action/setUsingGameId.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import { Game } from '../resource/gameConstants.js';

const mapStateToProps = state => {
  return {
    meId: getMeData(state, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onEnterGame: ({ streamId }) => {
      dispatch(setUsingGameId({ gameId: Game.UGPP_CUPID_GIFT }));
      // An aside-hosted game (e.g. sicbo) may still be open — the accordion
      // closes it so only the modal-hosted cupid game remains.
      dispatch(setLiveStreamPanel({ isGameOpen: false }));
      dispatch(
        toggleModal({
          modalId: 'HomeGameModal',
          isOpen: true,
          payload: { streamId },
        })
      );
      dispatch(toggleModal({ modalId: 'LiveStreamGiftModal', isOpen: false }));
    },
    login: () => dispatch(login()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamCupidGiftEntry);
